import { Component } from '@angular/core';

@Component({
  selector: 'lfw-menu-vertical-divider',
  template: ``,
  styles: `
    :host {
      border-bottom: solid 1px;
      width: 90%;
      border-color: var(--mat-app-text-color);
      margin: 6px;
      display: block;
    }
  `,
  standalone: true
})
export class MenuVerticalDividerComponent {}
